import {Box, styled} from "@mui/material";

const SkyBlueWrapper = styled(Box)(({theme}) => ({
    background: "linear-gradient(180deg, rgba(0, 133, 255, 0.75) 8.23%, rgba(0, 141, 254, 0.7) 86.41%)",
    color: "#fafafa",
}));
export default SkyBlueWrapper;